<template>
	<div>
		<el-dialog width="1200px" title="问题引用" :visible.sync="dialogTableVisible" append-to-body :close-on-click-modal="false">
			<div style="margin-bottom: 15px;display: flex;justify-content: space-between;">
				<el-input style="width: 300px;" placeholder="请搜索问题标签/问题标题" v-model="inputName" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="inquire"></el-button>
				</el-input>

				<el-button @click="FullReference">
					批量引用
					<span v-if="this.multipleSelection.length != 0">( {{ this.multipleSelection.length }} )</span>
				</el-button>
			</div>
			<el-table border max-height="500" ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" width="55"></el-table-column>
				<el-table-column align="center" label="问题标签">
					<template slot-scope="scope">
						{{ queryTag(scope.row.quesLabelName) }}
					</template>
				</el-table-column>
				<el-table-column align="center" label="问题标题">
					<template slot-scope="scope">
						{{ htmlToString(scope.row.questionsName) }}
					</template>
				</el-table-column>
				<el-table-column align="center" property="name" label="所属题库"></el-table-column>
				<el-table-column align="center" fixed="right" label="操作" width="120">
					<template slot-scope="scope">
						<el-button @click="referenceProblem(scope.row)" type="text" size="small">引用</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination style="margin-top: 10px; text-align: right;" layout="total" :total="tableTotal"></el-pagination>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		bankType: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			tableTotal: 0,
			inputName: '',
			tableData: [],
			temOptions: [], //题库列表
			multipleSelection: [],
			dialogTableVisible: false,

			//测试
			myOptions: [],
			manageBankList: [],
			systemOptions: [],
			paper: {
				questionsList: []
			}
		};
	},
	methods: {
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n|\s*/g, '');
		},
		referenceProblem(e) {
			this.$emit('quesFormBand', e);
			this.$message({
				message: '添加成功',
				type: 'success'
			});
		},
		queryTag(quesLabelName) {
			if (quesLabelName) {
				return quesLabelName.toString();
			} else {
				return '';
			}
		},
		inquire() {
			this.tableData = [];
			this.temOptions = [];
			this.loadData();
		},
		FullReference() {
			if (this.multipleSelection.length == 0) {
				this.$message({
					message: '请选择一条数据',
					type: 'warning'
				});
				return false;
			}
			this.multipleSelection.forEach(item => {
				this.$emit('quesFormBand', item);
			});
			this.$message({
				message: '添加成功',
				type: 'success'
			});
		},
		loadData() {
			this.tableData = [];
			this.temOptions = [];

			this.loadgetBankApi();
			// async function queryData() {
			//       var info = await axios.get('async1');
			//       //axios传递给服务器/async2接口的info.data参数,用于接口内部判断
			//       //传参格式：[ '地址？属性名=属性值' ]or [ ' 地址？对象= ' + '对象.属性名']
			//       var ret = await axios.get('async2?info=' + info.data);
			//       return ret.data;
			//     }
		},
		async loadgetBankApi() {
			await this.getBankApi(0);
			await this.getBankApi(1);
			this.inquireQuestion();
			this.dialogTableVisible = true;
		},

		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(this.multipleSelection);
		},
		inquireQuestion() {
			if (this.temOptions.length == 0) {
				this.tableData = [];
				this.dialogTableVisible = true;
				return false;
			}
			this.temOptions.forEach(info => {
				this.getQuestion({ bid: info.id });
			});
			this.dialogTableVisible = true;
		},
		getBankApi(isSystem) {
			return new Promise((resolve, reject) => {
				// 模拟异步调用
				let that = this;
				let data = this.$qs.stringify({
					isSystem: isSystem, // 0自建题库 1系统题库
					pageIndex: 1,
					pageSize: 10000,
					bankType: this.bankType, // 0考试题库 1问卷题库
					name: this.inputName
				});
				let params = {
					that: this,
					url: `${this.$config.service.examBankList}?${data}`,
					method: 'GET',
					cb(res) {
						// console.log(res);
						if (res.code == '0') {
							if (isSystem == 0) {
								if (that.temOptions.length > 0) {
									that.temOptions = [...that.temOptions, ...res.resultBody.datas];
								} else {
									that.temOptions = res.resultBody.datas;
								}
							} else {
								if (that.temOptions.length > 0) {
									that.temOptions = [...that.temOptions, ...res.resultBody.datas];
								} else {
									that.temOptions = res.resultBody.datas;
								}
							}
						}
						resolve()
					}
				};
				this.$util.request(params);
			});
		},
		getQuestion(obj) {
			if (obj.arr) {
				if (!obj.arr.questionsList) {
					this.$set(obj.arr[obj.i], 'questionsList', []);
				} else {
					obj.arr.questionsList = [];
				}
			}
			let that = this;
			let data = this.$qs.stringify({
				bankId: obj.bid, // 0自建题库 1系统题库
				difficulty: '',
				pageIndex: 1,
				pageSize: 10000,
				type: '', // 题库类别
				isDel: 0, // 是否为回收站列表
				bankType: this.bankType, // 是否为0考试 1问卷
				name: this.inputName
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankQuesList}?${data}`,
				method: 'GET',
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						let list = [];
						res.resultBody.datas.forEach((info, index) => {
							let quesJson = JSON.parse(info.quesJson);
							quesJson.bqid = info.id;
							quesJson.quesLabelName = quesJson.quesLabelName;
							quesJson.name = info.name;
							list.push(quesJson);
						});
						that.tableData = [...that.tableData, ...list];
						that.tableTotal = that.tableData.length;
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>
<style></style>
